import { render, staticRenderFns } from "./UserInfoCard.vue?vue&type=template&id=38c58c4d&scoped=true"
import script from "./UserInfoCard.vue?vue&type=script&lang=ts"
export * from "./UserInfoCard.vue?vue&type=script&lang=ts"
import style0 from "./UserInfoCard.vue?vue&type=style&index=0&id=38c58c4d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c58c4d",
  null
  
)

export default component.exports